import React from 'react';
import UserRoleManager from '../components/UserRoleManager';

/**
 * The header band lives in UserManagement / RoleManagement rather than here: this screen
 * hosts a two-view toggle, and a title on the shell would still read "User Management"
 * after the user switched to Roles.
 */
export const UsersPage: React.FC = () => {
  return (
    <div className="h-full flex flex-col overflow-auto bg-brand-bg">
      <UserRoleManager />
    </div>
  );
};
